import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AbpSessionService } from 'abp-ng2-module';
import { LazyLoadEvent } from 'primeng/api';
import { Paginator } from 'primeng/paginator';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, CalculationTimeAndAttendanceDto, ProjectTaskServiceProxy, TeamTaskDto, UserProjectTaskDto, UserProjectTaskListDto, UserStatusEnum, UserTaskListDashBoard } from '../../../../../shared/service-proxies/service-proxies';
import { FormatTrackedTimePipe } from '../../../time-tracking/pipes/format-tracked-time.pipe';
import { HoursToTimespanPipe } from '../../../time-tracking/pipes/hours-to-timespan.pipe';
import * as _ from 'lodash';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';


@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
    styleUrls: ['./task-list.component.css'],
    providers: [HoursToTimespanPipe, FormatTrackedTimePipe]

})
export class TaskListComponent extends AppComponentBase implements OnInit {
    @ViewChild("paginator", { static: true }) paginator: Paginator;

    taskDetails: UserProjectTaskDto[];
    isLoaded = false;
    isTaskListRecordsEmpty = false;
    statusIdCheck: number = 1;
    //filters
    assignedUserIdFilter: number[];
    stateIdFilter: number;
    projectFilter: number[];
    filterSearch: string = "";
    newestOnTop: boolean = true;
    oldestOnTop: boolean = false;
    isLoading = false;
    visible = true;
    selectedTeamTask: TeamTaskDto;
    projectId: any[];
    projectTaskId: number[];
     taskList = [];
    taskDetailsNew: UserTaskListDashBoard[];
    dateTime = new Date();
    msg:string;


    constructor(private _monitorService:MonitoringService,private _AllDashboardServiceProxy: AllDashboardServiceProxy, injector: Injector, private router: Router, private _projectTaskServiceProxy: ProjectTaskServiceProxy, private AbpSession:AbpSessionService
) { super(injector) }

    ngOnInit(): void {
        //this.getUserTaskListdetails();
        //this.getTeamTaskList();
        this.getDashboardTaskList();

  }
    //Old API call for task list
    //getUserTaskListdetails() {
      
    //    this._AllDashboardServiceProxy.getTaskList([], [], '', null, false).subscribe(result => {
    //        this.taskDetails = [];
    //        result.forEach(x => {
    //            if (x.projectImage === '') {
    //                x.projectImage = 'assets/common/images/default-profile-picture1.svg';
    //            }


    //            this.taskDetails.push(x);
    //            this.isTaskListRecordsEmpty = false;

            
              
    //        });
    //        if (this.taskDetails != null) {
    //            this.isLoaded = true;
    //        }
                
    //    });
        
    //}

    viewall() {
        this.router.navigate(['app/main/time-tracking/time-tracking']);
    }

    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }


    getUserlength(e: string) {
        return e?.length;
    }

//Updated API call for task-list data as per my task-list
/* async getTeamTaskList() {
     
        await this._projectTaskServiceProxy.getProjectWiseUserTaskList(
            this.projectId, this.projectTaskId, undefined, undefined, false, false).subscribe(x => {
                x.forEach(ele => {
                    ele.userTaskList.forEach(task => {
                        var obj =  {
                            projectName: ele.projectName,
                            image: ele.projectImage,
                            taskName: task.taskName,
                            taskActivityId: task.taskActivityId,
                            taskSeverityId: task.taskSeverityId,
                            completedHours: task.totalCompletedHours,
                            taskStatusId: task.taskStatusId,
                            billableType: task.billableType,
                            originalEstimatedHours: task.originalEstimatedHours
                        }
                        this.taskList.push(obj);
                    });

                    
                })
                this.taskDetails = x;
                this.isLoaded = true;
                if (this.taskDetails.length > 0) {  
                    this.isTaskListRecordsEmpty = true;
                    //console.log('Task', this.taskDetails);
                }
            })
        *//*await this._projectTaskServiceProxy.getProjectWiseUserTaskList(
            this.projectId, this.projectTaskId, undefined, 2, false, false).subscribe(x => {
                this.taskDetails = x;
                this.isLoaded = true;
                if (this.taskDetails.length > 0) {
                    this.isTaskListRecordsEmpty = true;
                }
               
            })
        await this._projectTaskServiceProxy.getProjectWiseUserTaskList(
            this.projectId, this.projectTaskId, undefined, 3, false, false).subscribe(x => {
                this.taskDetails = x;
                this.isLoaded = true;
                if (this.taskDetails.length > 0 ) {
                    this.isTaskListRecordsEmpty = true;
                }
               
            })
        await this._projectTaskServiceProxy.getProjectWiseUserTaskList(
                 this.projectId,this.projectTaskId,undefined,4,false,false).subscribe(x => {
                     this.taskDetails = x;
                     this.isLoaded = true;
                     if (this.taskDetails.length > 0) {
                         this.isTaskListRecordsEmpty = true;
                     }
                     //console.log('task', this.taskDetails);
                 })*//*
    
    }
*/
    async getDashboardTaskList() {
        this._monitorService.logTrace("UI-getDashboardTaskList",{"getDashboardTaskList ":"getDashboardTaskList: "+this.dateTime})
        await this._projectTaskServiceProxy.getTaskListForParticularUserDashBoard(this.AbpSession.userId, 5).subscribe(result => {
            this.taskDetailsNew = result;
            this.isLoaded = true;
            if (this.taskDetailsNew.length > 0) {
                this.isTaskListRecordsEmpty = true;
            }

        })
    }


    getOriginalEstimateHour(hour: number) {
        if (!hour) return "N/A";
        let hours = Math.floor(hour);
        let minutes = Math.floor((hour - Math.floor(hour)) * 60);
        return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes} h`;
    }

    getHrsAndMinutes(timestamp: string) {
        if (!timestamp) return '00h 00m';
        let hours = Math.floor(parseInt(timestamp.split(":")[0]));
        let min = parseInt(timestamp.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min} h`;
    }

    getUserStatus(id: UserStatusEnum) {
        //this._projectTaskServiceProxy.status
        return id != null ? UserStatusEnum[id] : "Unknown";
    }

}
  
